<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Chapter-Title-Page-Break--Body-" id="_idParaDest-1"><span class="CharOverride-2"><a id="_idTextAnchor000"></a>Contents</span></p>
<p class="ORIM-Body-Text-No-Indent-SpB4--Body-"><a href="#/Untitled118">TO GERALD DUCKWORTH</a></p>
<p class="ORIM-Body-Text-No-Indent-SpB4--Body-"><a href="#/Untitled119">PART I</a></p>
<p class="ORIM-Body-Text-No-Indent--Body-"><a href="#/Untitled120">CHAPTER I</a></p>
<p class="ORIM-Body-Text-No-Indent--Body-"><a href="#/Untitled121">CHAPTER II</a></p>
<p class="ORIM-Body-Text-No-Indent--Body-"><span href="#/Untitled122" title="Link target outside of Sample">CHAPTER III</span></p>
<p class="ORIM-Body-Text-No-Indent-SpB4--Body-"><span href="#/Untitled123" title="Link target outside of Sample">PART II</span></p>
<p class="ORIM-Body-Text-No-Indent--Body-"><span href="#/Untitled124" title="Link target outside of Sample">CHAPTER I</span></p>
<p class="ORIM-Body-Text-No-Indent--Body-"><span href="#/Untitled125" title="Link target outside of Sample">CHAPTER II</span></p>
<p class="ORIM-Body-Text-No-Indent--Body-"><span href="#/Untitled126" title="Link target outside of Sample">CHAPTER III</span></p>
<p class="ORIM-Body-Text-No-Indent--Body-"><span href="#/Untitled127" title="Link target outside of Sample">CHAPTER IV</span></p>
<p class="ORIM-Body-Text-No-Indent--Body-"><span href="#/Untitled128" title="Link target outside of Sample">CHAPTER V</span></p>
<p class="ORIM-Body-Text-No-Indent--Body-"><span href="#/Untitled129" title="Link target outside of Sample">CHAPTER VI</span></p>
<p class="ORIM-Body-Text-No-Indent-SpB4--Body-"><span href="#/Untitled130" title="Link target outside of Sample">PART III</span></p>
<p class="ORIM-Body-Text-No-Indent--Body-"><span href="#/Untitled131" title="Link target outside of Sample">CHAPTER I</span></p>
<p class="ORIM-Body-Text-No-Indent--Body- _idGenParaOverride-1"><span href="#/Untitled132" title="Link target outside of Sample">CHAPTER II</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled117.vue?77122745